// deps
import React, { memo, useEffect, useState } from "react";

// dls
import { CheckboxGroup } from "@swiggy-private/dls-web-core/dist/components/Checkbox";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import { ContentHeader } from "./styles";

import { TEXTS } from "../constants";

// helpers
import { transformFilterObject } from "../helpers";
import { IFilterContent } from "../types";

function MultiSelectContent({ filter, updateFilterList, selectedFilters }: IFilterContent) {
    const [values, setValues] = useState(selectedFilters);

    useEffect(() => {
        setValues(selectedFilters);
    }, [selectedFilters]);
    return (
        <>
            <ContentHeader>
                <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                    {filter?.subLabel ?? TEXTS.FILTER_BY}
                </Text>
            </ContentHeader>
            <CheckboxGroup
                name={filter.label}
                value={values}
                items={transformFilterObject(filter?.facetInfo)}
                onChange={(v) => {
                    setValues(v);
                    updateFilterList(v, filter.id);
                }}
            />
        </>
    );
}

export default memo(MultiSelectContent);
